import type { SystemStyleObject } from '@styled-system/css';

const LTR = 'html[dir=ltr] &';
const RTL = 'html[dir=rtl] &';
interface DirectionStyles {
  [LTR]: SystemStyleObject;
  [RTL]: SystemStyleObject;
}
type LeftRight = 'Left' | 'Right';
type CreateConsistentInlineProps = (
  dir1: LeftRight,
  dir2: LeftRight
) => (SystemStyleObject) => DirectionStyles;

const parseProp = (prop) => {
  const parsed = prop.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');
  return parsed.length > 2
    ? [parsed.slice(0, -1).join(''), parsed.slice(-1)]
    : parsed;
};

const oppositePositionPropsMap = {
  left: 'right',
  right: 'left',
};
const samePositionProp = (prop) =>
  oppositePositionPropsMap[prop] ? prop : null;
const oppositePositionProp = (prop) => oppositePositionPropsMap[prop] || null;
const buildProp = ([prop, ...rest], side, transform) => {
  return transform(prop) || [prop, side, ...rest].join('');
};

const createConsistentInlineProps: CreateConsistentInlineProps =
  (dir1, dir2) => (props) => {
    return Object.entries(props).reduce(
      (cssProps, [prop, value]) => {
        const parsedProp = parseProp(prop);
        const ltrProp = buildProp(parsedProp, dir1, samePositionProp);
        const rightProp = buildProp(parsedProp, dir2, oppositePositionProp);
        cssProps[LTR][ltrProp] = value;
        cssProps[RTL][rightProp] = value;
        return cssProps;
      },
      {
        [LTR]: {},
        [RTL]: {},
      }
    );
  };
export const inlineStart = createConsistentInlineProps('Left', 'Right');
export const inlineEnd = createConsistentInlineProps('Right', 'Left');
